import * as React from 'react';

const SvgComponent = props => (
  <svg
    id="planner-end-points-and-path-icon"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 390 390"
    style={{
      enableBackground: 'new 0 0 390 390'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.240dvdjs{fill:#fff}'}</style>
    <circle className="240dvdjs" cx={173.6} cy={332.9} r={11.7} />
    <circle className="240dvdjs" cx={266.8} cy={261.6} r={11.7} />
    <circle className="240dvdjs" cx={220.2} cy={297.2} r={11.7} />
    <path
      className="240dvdjs"
      d="m311.8 238.2-6.2-7.6c-2.9-3.7-71.8-89.8-71.8-152.6 0-43 35-78 78-78s78 35 78 78c0 62.8-68.9 149-71.8 152.6l-6.2 7.6zm0-222.4c-34.3 0-62.2 27.9-62.2 62.2 0 46.9 45.4 112.1 62.2 134.7C328.6 190.1 374 124.9 374 78c0-34.3-27.9-62.2-62.2-62.2z"
    />
    <circle className="240dvdjs" cx={311.8} cy={79} r={32} />
    <path
      className="240dvdjs"
      d="M102.1 77.5C45.7 77.5-.2 123.4-.2 179.8-.2 262.2 90.2 375.2 94 380l8.1 10 8.1-10c3.8-4.8 94.2-117.8 94.2-200.2 0-56.4-45.9-102.3-102.3-102.3zm0 151.6c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    />
  </svg>
);

export default SvgComponent;
